/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/order */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

import PageLoader from "components/common/PageLoader";
import Button from "components/common/Button";
import EmployeePayrollCardV2 from "components/EmployeePayrollCardV2/EmployeePayrollCardV2";
import PayrollHistory from "components/Screens/PayrollV2/PayrollHistory";

import { usePermissions } from "components/Hook";
import { hasPermission } from "hooks/usePermission";
import PageToolBar from "components/Widgets/PageToolBar";
import Tabs from "components/common/Tabs";
import TopHeader from "components/common/TopHeader";
import CustomChip from "components/common/Chip";
import CustomTooltip from "components/common/Tooltip";
import Text from "components/common/Text";

import useBreadcrumbs from "hooks/useBreadcrumbs";

import {
  convertDate,
  currencyFormat,
  getFieldValue,
  getMonthFromDate,
  getUTCMonthName,
  getValue,
  handleRetryPayment,
  isEmptyObject,
} from "components/Screens/CommonUtils";

import { baseUrl } from "util/APIBaseUrl";
import { RetryPayment } from "store/actions/Payment/RetryPayment";
import { EmployeeInfo } from "store/actions/EmployeeInfo";
import { PayrollSummary } from "store/actions/PayrollSummary";
import { UserAdditionalInfo } from "store/actions/UserAdditionalInfo";
import getRequest from "util/APIHelperGet";

import { CUSTOMER_PAYROLL_HISTORY, CUSTOMER_PAYROLL } from "constants/routes";

import FailureIcon from "assets/svgs/PayrolFailure";
import SuccessIcon from "assets/svgs/PayrolSuccess";
import PendingIcon from "assets/svgs/PayrolPending";
import DownloadIcon from "assets/svgs/PayrolDownloadIcon";
import RetryIcon from "assets/svgs/RetryIcon";
import EditPayrollIcon from "assets/svgs/EditPayrollIcon";
import {
  PeopleOutlineOutlined as PeopleOutlineOutlinedIcon,
  InfoOutlined as InfoOutlinedIcon,
  Search,
} from "@mui/icons-material";

import "./Payroll.scss";

function Payroll(props) {
  const { selectPageHeading } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const { loggedInUser, loggedInUserType } = usePermissions();
  const { platformHeader, customizedInvoicing } = useFlags();
  const { setLabel, resetLabels } = useBreadcrumbs();

  const [tab, setTab] = useState(search ? 2 : 1);
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedRowID] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [updatedSalaries, setUpdatedSalaries] = useState(false);
  const [firstPayment, setFirstPayment] = useState({});

  const { amount, invoiceUrl, paymentStatus, chargeDate } = firstPayment ?? {};
  const payrollData = [];

  const canEditPayroll = hasPermission("payroll.addRaise") || hasPermission("payroll.awardBonus");
  const canRetryPayment = hasPermission("payments.retry");
  const canExportPayroll = hasPermission("payroll.export");

  const employeesInfo = useSelector((state) => state.EmployeeInfo.employeesInfo);
  const loadingEmployeesInfo = useSelector((state) => state.EmployeeInfo.loadingEmployeesInfo);

  const userAdditionalInfo = useSelector((state) => state.UserAdditionalInfo.userAdditionalInfo);
  const loadingAdditionalInfo = useSelector((state) => state.UserAdditionalInfo.loadingAdditionalInfo);

  const paymentDetails = useSelector((state) => state.GetPaymentDetails.paymentDetails);
  const loadingPaymentDetails = useSelector((state) => state.GetPaymentDetails.loadingPaymentDetails);

  const getEmployeeDetails = useSelector((state) => state.GetEmployeeDetails.getEmployeeDetails);
  const loadingGET_EMPLOYEE_Details = useSelector((state) => state.GetEmployeeDetails.loadingGET_EMPLOYEE_Details);

  const loadingPayrollSummary = useSelector((state) => state.PayrollSummary.loadingPayrollSummary);

  const {
    paymentDate,
    totalPayroll,
    totalEmployees,
    totalBonus,
    totalIncrementRaise,
    creditAmount,
    updatedEmployeePayrolls,
    lastPayroll,
  } = userAdditionalInfo || {};

  const {
    payrollMonth: lastPayrollMonth,
    totalAmount: lastPayrollTotalAmount,
    paymentDate: lastPayrollPaymentDate,
    creditAmount: lastPayrollCreditAmount,
    totalBonus: lastPayrollTotalBonus,
    totalEmployees: lastPayrollTotalEmployees,
    failure: lastPayrollFailure,
    manualPaymentFailed: lastPayrollManualPaymentFailed,
    status: lastPayrollStatus,
    customerPayrollId: lastPayrollCustomerPayrollId,
  } = lastPayroll || {};

  const getTotalEmployees = useCallback(() => {
    return updatedSalaries ? employeesInfo?.filteredCount : employeesInfo?.count;
  }, [updatedSalaries, employeesInfo]);

  const handleSearchEmployee = (event) => {
    if (event.target.value !== "") {
      const filteredEmployee = employees.filter((item) => {
        return item.name.toLowerCase().includes(event.target.value.toLowerCase());
      });
      setEmployeeList(filteredEmployee);
    } else {
      setEmployeeList(employees);
    }
  };

  const getPayrollstatus = useCallback(() => {
    return isEmptyObject(userAdditionalInfo)
      ? lastPayroll
        ? lastPayrollFailure
          ? "Transaction Failed"
          : !lastPayrollFailure && lastPayrollStatus === "pending"
            ? "Transaction In progress"
            : !lastPayrollFailure && lastPayrollStatus === "paid"
              ? "Transaction Successful"
              : "No Bill Found"
        : "No Bill Found"
      : "-";
  }, [userAdditionalInfo, lastPayrollFailure, lastPayrollStatus]);

  function getPayrollStatusIcon() {
    const statusConfig = {
      processing: {
        backgroundColor: "#FFEFD3",
        icon: <PendingIcon />,
      },
      pending: {
        backgroundColor: "#FFEFD3",
        icon: <PendingIcon />,
      },
      paid: {
        backgroundColor: "#B4FFF2",
        icon: <SuccessIcon />,
      },
      failed: {
        backgroundColor: "#FFDAD6",
        icon: <FailureIcon />,
      },
    };

    const config = statusConfig[paymentStatus] || statusConfig.failed;

    return (
      <div
        style={{
          padding: "12px",
          backgroundColor: config.backgroundColor,
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {config.icon}
      </div>
    );
  }

  const handleFirstPaymentClick = () => navigate("firstPayment");

  useEffect(() => {
    if (isEmptyObject(loggedInUser)) {
      dispatch(
        EmployeeInfo({
          customerID: loggedInUser?.customerId,
          rowsPerPage: 500,
          page: 0,
          sortBy: null,
          dist: {
            updated: updatedSalaries,
          },
        })
      );
    }
  }, [loggedInUser, updatedSalaries]);

  useEffect(() => {
    if (getEmployeeDetails.ok) {
      if (selectedRowID != null) {
        navigate(`/main/details/${selectedRowID}`);
      }
    }
  }, [getEmployeeDetails]);

  useEffect(() => {
    if (employeesInfo && Object.keys(employeesInfo).length && employeesInfo?.rows?.length) {
      employeesInfo.rows.forEach((employee) => {
        payrollData.push({
          picturePath: employee?.picturePath,
          pictureVersion: employee?.pictureVersion,
          id: employee.employeeId,
          profilePicture: `${baseUrl}/employee/${employee.employeeId}/logo?id=${employee?.pictureVersion}`,
          name: `${getValue(employee.firstName)} ${getValue(employee.lastName)}`,
          role: getValue(employee.jobTitle),
          email: getValue(employee.email),
          country: getValue(employee.country),
          costToCompany: getFieldValue(employee?.costToCompany),
          incrementDetails: getFieldValue(employee?.incrementDetails),
          bonus: getFieldValue(employee?.incrementDetails?.bonus),
          edgeJoiningDate: convertDate(employee.startDate),
        });
      });
    }

    setEmployees(payrollData);
    setEmployeeList(payrollData);
  }, [employeesInfo]);

  useEffect(() => {
    if (Object.keys(paymentDetails).length && paymentDetails?.ok) {
      selectPageHeading("Payroll Details");
    }
  }, [paymentDetails]);

  useEffect(() => {
    if (isEmptyObject(loggedInUser)) {
      const reqUrl = {
        edge: `user/${loggedInUser.userId}/summary`,
        customer: `customer/${loggedInUser.customerId}/info`,
        employee: `employee/${loggedInUser.userId}`,
      };
      dispatch(UserAdditionalInfo(reqUrl[loggedInUserType]));
    }

    dispatch(
      PayrollSummary({
        customerID: loggedInUser?.customerId,
        rowsPerPage: 6,
        page: 0,
      })
    );
  }, [loggedInUser]);

  useEffect(() => {
    const fetchOnboardingDetails = async () => {
      const response = await getRequest(`${baseUrl}/customer/${loggedInUser.customerId}/charge/onboarding`, true);
      if (response?.ok) {
        setFirstPayment(response?.payload?.chargeDetails);
      } else {
        setFirstPayment({});
      }
    };
    fetchOnboardingDetails();
  }, []);

  useEffect(() => {
    if (search) {
      setTab(2);
      return;
    }
    setTab(1);
  }, [search]);

  useEffect(() => {
    if (userAdditionalInfo?.paymentDate) {
      const monthName = getUTCMonthName(paymentDate);
      setLabel(pathname, `Billing for ${monthName}`);
    } else {
      setLabel(pathname, "Billing");
    }

    return () => resetLabels();
  }, [userAdditionalInfo, paymentDate, pathname]);

  const handleTabChange = (newTab) => {
    setTab(newTab + 1);
    if (newTab + 1 === 2) {
      navigate(CUSTOMER_PAYROLL_HISTORY);
    } else {
      navigate(CUSTOMER_PAYROLL);
    }
  };

  return (
    <>
      <Helmet>
        <title>Edge | Billing</title>
      </Helmet>
      {loadingGET_EMPLOYEE_Details ||
      loadingAdditionalInfo ||
      loadingPayrollSummary ||
      loadingPaymentDetails ||
      loadingEmployeesInfo ? (
        <PageLoader />
      ) : null}

      <div className="payroll-v2-container">
        <div className="payroll-v2-header">
          <TopHeader
            title={tab === 1 ? `Billing for ${getUTCMonthName(paymentDate)}` : "Invoices"}
            linkName="Billing"
            link={tab === 1 ? CUSTOMER_PAYROLL : CUSTOMER_PAYROLL_HISTORY}
            breadcrumbs={!platformHeader}
            backIcon={platformHeader ? "" : "/main/dashboard"}
          />

          <div className="payrol-tabs-container">
            {customizedInvoicing ? (
              <Tabs
                tabs={[{ label: `${getUTCMonthName(paymentDate)} Bill` }, { label: "Invoices" }]}
                tab={tab - 1}
                setTab={handleTabChange}
              />
            ) : (
              <PageToolBar
                tab1Title={{
                  title: `${getUTCMonthName(paymentDate)} Bill`,
                  navLink: CUSTOMER_PAYROLL,
                }}
                tab2Title={{
                  title: "Invoices",
                  navLink: CUSTOMER_PAYROLL_HISTORY,
                }}
                tab={tab}
                setTab={setTab}
              />
            )}
          </div>
        </div>

        <div className="payroll-v2-content-container">
          <div className="payroll-v2-content">
            {tab === 1 && (
              <>
                <div className="payroll-stats-section-redesigned">
                  <div className="payroll-stats-container">
                    <div className="payroll-main-card">
                      <div className="payroll-main-card-content">
                        <div className="payroll-main-top-row">
                          <div className="payroll-main-stat">
                            <div className="payroll-main-value" id="total-payroll">
                              ${currencyFormat(getFieldValue(totalPayroll))}
                            </div>
                            <div className="payroll-main-stat-text">Due on {convertDate(paymentDate)}</div>
                          </div>

                          <div className="payroll-main-stat">
                            <div className="payroll-main-value">
                              {creditAmount ? `$${currencyFormat(getFieldValue(creditAmount))}` : "-"}
                            </div>
                            <div className="payroll-main-label-with-icon payroll-main-stat-text">
                              Credit adjusted
                              <CustomTooltip
                                content={
                                  <div className="para-body-xs-medium">
                                    A part of your payment covered by previously issued credit or adjustments.
                                  </div>
                                }
                                arrow={false}
                                placement="bottom"
                              >
                                <InfoOutlinedIcon className="payroll-info-icon" fontSize="small" />
                              </CustomTooltip>
                            </div>
                          </div>

                          <div className="payroll-main-stat">
                            <div className="payroll-main-value" id="total-employees">
                              {getFieldValue(totalEmployees)}
                            </div>
                            <div className="payroll-main-stat-text">Employees</div>
                          </div>
                        </div>

                        <div className="payroll-main-bottom-row">
                          <div className="payroll-main-title">Total Bill</div>
                        </div>
                      </div>
                    </div>

                    <div className="payroll-secondary-card">
                      <div className="payroll-secondary-card-content">
                        <div className="payroll-secondary-top-row">
                          <div className="payroll-secondary-stat">
                            <div className="payroll-main-value" id="bonus-added">
                              $ {currencyFormat(getFieldValue(totalBonus))}
                            </div>
                            <div className="payroll-main-stat-text">Bonus Added</div>
                          </div>

                          <div className="payroll-secondary-stat">
                            <div className="payroll-main-value" id="raise-added">
                              $ {currencyFormat(getFieldValue(totalIncrementRaise)) || 0}
                            </div>
                            <div className="payroll-main-stat-text">Raise Added</div>
                          </div>
                        </div>

                        <div className="payroll-secondary-bottom-row">
                          <div className="payroll-main-title" id="no-of-emp-bonus">
                            {getFieldValue(updatedEmployeePayrolls?.filteredCountBonus) || 0} employees
                          </div>
                          <div className="payroll-main-title" id="no-of-emp-raise">
                            {getFieldValue(updatedEmployeePayrolls?.filteredCountIncrement) || 0} employees
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {getTotalEmployees() > 0 && lastPayroll && (
                  <div className="payroll-last-month-section-v2">
                    <div className="payroll-last-month-card-v2">
                      <div className="payroll-last-month-stats-v2">
                        <div className="payroll-last-month-stat-item">
                          <div className="payroll-main-value">{getMonthFromDate(lastPayrollMonth)}</div>
                          <div className="payroll-main-stat-text">Last month's bill</div>
                        </div>
                        <div className="payroll-last-month-stat-item">
                          <div className="payroll-main-value">
                            ${currencyFormat(getFieldValue(lastPayrollTotalAmount))}
                          </div>
                          <div className="payroll-main-stat-text">Paid on {convertDate(lastPayrollPaymentDate)}</div>
                        </div>

                        <div className="payroll-last-month-stat-item">
                          <div className="payroll-main-value">
                            {lastPayrollCreditAmount
                              ? `$${currencyFormat(getFieldValue(lastPayrollCreditAmount))}`
                              : "-"}
                          </div>
                          <div className="payroll-main-stat-text">Credit adjusted</div>
                        </div>

                        <div className="payroll-last-month-stat-item">
                          <div className="payroll-main-value">
                            ${currencyFormat(getFieldValue(lastPayrollTotalBonus))}
                          </div>
                          <div className="payroll-main-stat-text">Bonus added</div>
                        </div>

                        <div className="payroll-last-month-stat-item">
                          <div className="payroll-main-value">{getValue(lastPayrollTotalEmployees)}</div>
                          <div className="payroll-main-stat-text">Number of Employees</div>
                        </div>

                        <div className="payroll-last-month-status">
                          {getPayrollstatus() === "Transaction Failed" ? (
                            // [PRD-3752] Finance marked it failed: settled via Update Payment Status, never retried.
                            canRetryPayment &&
                            !lastPayrollManualPaymentFailed && (
                              <Button
                                variant="outlined"
                                size="xs"
                                id="retry-failed-payment"
                                aria-label="Retry failed payment"
                                leadIcon={<RetryIcon />}
                                onClick={() =>
                                  handleRetryPayment(
                                    loggedInUser?.customerId,
                                    lastPayrollCustomerPayrollId,
                                    dispatch,
                                    RetryPayment
                                  )
                                }
                                label="Retry"
                              />
                            )
                          ) : (
                            <CustomChip color="success" label="Transaction Successful" />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="payroll-employee-section">
                  {getTotalEmployees() > 0 && (
                    <div className="heading-h5-medium color-text-heading-primary mb-075">
                      Employees ({getTotalEmployees()})
                    </div>
                  )}

                  {getTotalEmployees() > 0 && (
                    <div className="payroll-actions-controls-row">
                      <div className="payroll-left-controls">
                        <div className="payroll-search-container">
                          <Text
                            type="search"
                            id="search-employees"
                            onChange={handleSearchEmployee}
                            placeholder="Search employees"
                            endIcon={<Search />}
                          />
                        </div>
                        <Button
                          variant="outlined"
                          id="view-updated-salaries"
                          size="md"
                          onClick={() => setUpdatedSalaries(!updatedSalaries)}
                          className={`payroll-filter-button-v2 ${updatedSalaries ? "active" : ""}`}
                          label="View Updated Billing"
                        />
                      </div>
                      <div className="payroll-right-controls">
                        {canEditPayroll && (
                          <Button
                            variant="contained"
                            size="md"
                            id="edit-payroll-for-month"
                            aria-label="Add Increment/Bonus"
                            startIcon={<EditPayrollIcon />}
                            onClick={() => navigate("/main/customers/editPayroll")}
                            label="Add Increment/Bonus"
                          />
                        )}
                      </div>
                    </div>
                  )}

                  {getTotalEmployees() === 0 && updatedSalaries && (
                    <div className="payroll-empty-state">
                      <div className="payroll-empty-icon">
                        <PeopleOutlineOutlinedIcon />
                      </div>
                      <div className="payroll-empty-title">No results found</div>
                    </div>
                  )}

                  {getTotalEmployees() === 0 && !updatedSalaries && (
                    <div className="payroll-empty-state">
                      <div className="payroll-empty-icon">
                        <PeopleOutlineOutlinedIcon />
                      </div>
                      <div className="payroll-empty-title">Your employee(s) are being onboarded</div>
                      <div className="payroll-empty-description">
                        We're onboarding your employee(s) to the platform. Once this process is complete, you'll be able
                        to view their charges here.
                      </div>
                    </div>
                  )}

                  {employeeList?.length > 0 && (
                    <div className="payroll-employees-grid-v2">
                      {employeeList.map((employee) => (
                        <EmployeePayrollCardV2 key={employee.id} employee={employee} />
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          {tab === 2 && (
            <div className="payroll-history-section">
              <PayrollHistory />

              {!!Object.keys(firstPayment).length && !customizedInvoicing && (
                <div className="payroll-first-payment">
                  <div className="heading-h5-semibold color-text-heading-primary">First Payment</div>
                  <div className="first-payment-wrapper" onClick={handleFirstPaymentClick}>
                    <div className="flex items-center gap-075">
                      {getPayrollStatusIcon()}
                      <div>
                        <div className="heading-h5-semibold color-text-heading-primary">
                          {getUTCMonthName(chargeDate)} payment of ${currencyFormat(amount)}
                        </div>
                        <div className="para-body-s-regular color-text-heading-secondary">
                          {paymentStatus === "pending" &&
                            "We've received your payment details, and it is currently being processed."}
                          {paymentStatus === "paid" && "Your payment has been successfully received."}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center pr-5" onClick={(e) => e.stopPropagation()}>
                      {canExportPayroll && (
                        <Button
                          variant="outlined"
                          disabled={!invoiceUrl}
                          leadIconColor="#131599"
                          size="xs"
                          aria-label="Download Receipt"
                          onClick={() => window.open(invoiceUrl, "_blank")}
                          leadIcon={<DownloadIcon />}
                          label="Download Receipt"
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Payroll;
